// src/App.js
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import AppAccess from './pages/AppAccess';
import LoginAccess from './pages/LoginAccess';
import DistribuiProPrivacy from './pages/DistribuiProPrivacy';
import ProtectedRoute from './components/ProtectedRoute';
import WhatsAppFloat from './pages/WhatsAppFloat';
import './App.css';
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
// ...tus imports

function ScrollHandler() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Si hay hash -> intentamos hacer scroll al elemento
    if (hash) {
      const el = document.getElementById(hash.slice(1));
      if (el) {
        // pequeño delay para asegurar que el layout esté listo
        setTimeout(() => {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 0);
      }
    } else {
      // sin hash -> scrollear arriba en cada cambio de ruta
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [pathname, hash]);

  return null;
}


function App() {
  return (
    <Router>
      <ScrollHandler /> {/* <-- agrega esto aquí */}
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<LoginAccess />} />
          <Route path="/privacidad-distribuipro" element={<DistribuiProPrivacy />} />
          <Route
            path="/app"
            element={
              <ProtectedRoute>
                <AppAccess />
              </ProtectedRoute>
            }
          />
        </Routes>
        <Footer />
         <WhatsAppFloat />
      </div>
    </Router>
  );
}

export default App;
